import { Link } from "react-router-dom";

const Navbar = ({ handleReset }) => {
  return (
    <div className="navbar">
      <h1>The Dojo Blog</h1>
      <div className="links">
        <button className="navButton" onClick={handleReset}>
          Reset Blogs
        </button>
        <Link to="/">Home</Link>
        <Link to="/create">New Blog</Link>
      </div>
    </div>
  );
};

export default Navbar;
